// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DiscountModal_overlay__H9vPW{
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  z-index: 9999;
}

.DiscountModal_modal__3WEs3{
  width: 320px;              /* было больше — сжали */
  max-width: 92vw;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 18px 55px rgba(0,0,0,.18);
  padding: 14px;
}

.DiscountModal_title__vQ3d9{
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 10px;
  color: #1f2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.DiscountModal_row__VMmsm{
  margin-bottom: 10px;
}


.DiscountModal_input__K0i0d,
.DiscountModal_select__eKw2H{
  width: 100%;
  height: 42px;              /* компакт */
  border: 1px solid rgba(0,0,0,.12);
  border-radius: 12px;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
  background: #fff;
}

.DiscountModal_input__K0i0d.DiscountModal_active__jtKkX{
  border-color: rgba(29,135,82,1);
  box-shadow: 0 0 0 3px rgba(29,135,82,.12);
}

.DiscountModal_select__eKw2H{
  color: #111827;
}

.DiscountModal_discountLine__TUpAy{
  display: grid;
  grid-template-columns: 1fr 44px 44px;  /* компакт */
  gap: 8px;
  align-items: center;
}

.DiscountModal_discountInputWrap__ds1sd{
  position: relative;
}

.DiscountModal_hint__GvI\\+o{
  position: absolute;
  right: 10px;
  bottom: 6px;
  font-size: 10px;
  color: rgba(0,0,0,.45);
}

.DiscountModal_toggle__T9AYX{
  height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(0,0,0,.12);
  background: #fff;
  cursor: pointer;
  font-weight: 700;
  display: flex;                 /* центрируем */
  align-items: center;
  justify-content: center;
}

.DiscountModal_toggleActive__xTvgg{
  border-color: rgba(29,135,82,1);
  background: rgba(29,135,82,.12);
  color: rgba(29,135,82,1);
}

.DiscountModal_preview__P92JZ{
  margin-top: 8px;
  border-radius: 12px;
  background: rgba(29,135,82,.06);   /* больше зелёного */
  padding: 10px;
  border: 1px solid rgba(29,135,82,.10);
}

.DiscountModal_previewRow__b6pEu,
.DiscountModal_previewRowStrong__-Unjy{
  display: flex;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  color: rgba(0,0,0,.75);
  margin: 4px 0;
}

.DiscountModal_previewRowStrong__-Unjy{
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.DiscountModal_strike__Vt8RV{
  text-decoration: line-through;
  color: rgba(0,0,0,.55);
}

.DiscountModal_green__yH9KP{
  color: rgba(29,135,82,1);
  font-weight: 700;
}

.DiscountModal_pad__RdDFm{
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.DiscountModal_padBtn__rlN6J,
.DiscountModal_padBtnWide__5JuGk{
  height: 44px;                 /* компактнее */
  border-radius: 14px;
  border: 1px solid rgba(29,135,82,.18);
  background: rgba(29,135,82,.08);
  cursor: pointer;
  font-size: 16px;
  font-weight: 800;
  color: rgba(29,135,82,1);

  display: flex;                /* центрируем цифры/иконки */
  align-items: center;
  justify-content: center;
}

.DiscountModal_padBtn__rlN6J:hover,
.DiscountModal_padBtnWide__5JuGk:hover{
  background: rgba(29,135,82,.14);
}

.DiscountModal_padBtn__rlN6J:active,
.DiscountModal_padBtnWide__5JuGk:active{
  transform: translateY(1px);
}

.DiscountModal_padBtn__rlN6J:disabled{
  opacity: .35;
  cursor: not-allowed;
  background: rgba(0,0,0,.04);
  border-color: rgba(0,0,0,.10);
  color: rgba(0,0,0,.45);
}


.DiscountModal_padBtnWide__5JuGk{
  grid-column: span 2;
}

.DiscountModal_actions__Y0XZQ{
  margin-top: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.DiscountModal_save__buzW9{
  height: 42px;
  padding-left: 5px;
  border-radius: 12px;
  border: none;
  background: rgba(29,135,82,1);
  color: #fff;
  font-weight: 800;
  cursor: pointer;
}

.DiscountModal_save__buzW9:hover{
  filter: brightness(0.95);
}

.DiscountModal_cancel__E7KVA{
  padding-left: 5px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(29,135,82,.35);
  background: #fff;
  color: rgba(29,135,82,1);
  font-weight: 800;
  cursor: pointer;
}

.DiscountModal_cancel__E7KVA:hover{
  background: rgba(29,135,82,.08);
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/DiscountModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,YAAY,eAAe,wBAAwB;EACnD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;;EAEE,WAAW;EACX,YAAY,eAAe,YAAY;EACvC,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC,GAAG,YAAY;EACnD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa,kBAAkB,eAAe;EAC9C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B,IAAI,oBAAoB;EACvD,aAAa;EACb,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;;EAEE,YAAY,kBAAkB,eAAe;EAC7C,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;;EAExB,aAAa,iBAAiB,4BAA4B;EAC1D,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".overlay{\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px;\n  z-index: 9999;\n}\n\n.modal{\n  width: 320px;              /* было больше — сжали */\n  max-width: 92vw;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 18px 55px rgba(0,0,0,.18);\n  padding: 14px;\n}\n\n.title{\n  font-size: 14px;\n  font-weight: 700;\n  text-align: center;\n  margin-bottom: 10px;\n  color: #1f2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.row{\n  margin-bottom: 10px;\n}\n\n\n.input,\n.select{\n  width: 100%;\n  height: 42px;              /* компакт */\n  border: 1px solid rgba(0,0,0,.12);\n  border-radius: 12px;\n  padding: 0 12px;\n  font-size: 14px;\n  outline: none;\n  background: #fff;\n}\n\n.input.active{\n  border-color: rgba(29,135,82,1);\n  box-shadow: 0 0 0 3px rgba(29,135,82,.12);\n}\n\n.select{\n  color: #111827;\n}\n\n.discountLine{\n  display: grid;\n  grid-template-columns: 1fr 44px 44px;  /* компакт */\n  gap: 8px;\n  align-items: center;\n}\n\n.discountInputWrap{\n  position: relative;\n}\n\n.hint{\n  position: absolute;\n  right: 10px;\n  bottom: 6px;\n  font-size: 10px;\n  color: rgba(0,0,0,.45);\n}\n\n.toggle{\n  height: 42px;\n  border-radius: 12px;\n  border: 1px solid rgba(0,0,0,.12);\n  background: #fff;\n  cursor: pointer;\n  font-weight: 700;\n  display: flex;                 /* центрируем */\n  align-items: center;\n  justify-content: center;\n}\n\n.toggleActive{\n  border-color: rgba(29,135,82,1);\n  background: rgba(29,135,82,.12);\n  color: rgba(29,135,82,1);\n}\n\n.preview{\n  margin-top: 8px;\n  border-radius: 12px;\n  background: rgba(29,135,82,.06);   /* больше зелёного */\n  padding: 10px;\n  border: 1px solid rgba(29,135,82,.10);\n}\n\n.previewRow,\n.previewRowStrong{\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n  color: rgba(0,0,0,.75);\n  margin: 4px 0;\n}\n\n.previewRowStrong{\n  font-size: 13px;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.strike{\n  text-decoration: line-through;\n  color: rgba(0,0,0,.55);\n}\n\n.green{\n  color: rgba(29,135,82,1);\n  font-weight: 700;\n}\n\n.pad{\n  margin-top: 10px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.padBtn,\n.padBtnWide{\n  height: 44px;                 /* компактнее */\n  border-radius: 14px;\n  border: 1px solid rgba(29,135,82,.18);\n  background: rgba(29,135,82,.08);\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 800;\n  color: rgba(29,135,82,1);\n\n  display: flex;                /* центрируем цифры/иконки */\n  align-items: center;\n  justify-content: center;\n}\n\n.padBtn:hover,\n.padBtnWide:hover{\n  background: rgba(29,135,82,.14);\n}\n\n.padBtn:active,\n.padBtnWide:active{\n  transform: translateY(1px);\n}\n\n.padBtn:disabled{\n  opacity: .35;\n  cursor: not-allowed;\n  background: rgba(0,0,0,.04);\n  border-color: rgba(0,0,0,.10);\n  color: rgba(0,0,0,.45);\n}\n\n\n.padBtnWide{\n  grid-column: span 2;\n}\n\n.actions{\n  margin-top: 12px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.save{\n  height: 42px;\n  padding-left: 5px;\n  border-radius: 12px;\n  border: none;\n  background: rgba(29,135,82,1);\n  color: #fff;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.save:hover{\n  filter: brightness(0.95);\n}\n\n.cancel{\n  padding-left: 5px;\n  height: 42px;\n  border-radius: 12px;\n  border: 1px solid rgba(29,135,82,.35);\n  background: #fff;\n  color: rgba(29,135,82,1);\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.cancel:hover{\n  background: rgba(29,135,82,.08);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `DiscountModal_overlay__H9vPW`,
	"modal": `DiscountModal_modal__3WEs3`,
	"title": `DiscountModal_title__vQ3d9`,
	"row": `DiscountModal_row__VMmsm`,
	"input": `DiscountModal_input__K0i0d`,
	"select": `DiscountModal_select__eKw2H`,
	"active": `DiscountModal_active__jtKkX`,
	"discountLine": `DiscountModal_discountLine__TUpAy`,
	"discountInputWrap": `DiscountModal_discountInputWrap__ds1sd`,
	"hint": `DiscountModal_hint__GvI+o`,
	"toggle": `DiscountModal_toggle__T9AYX`,
	"toggleActive": `DiscountModal_toggleActive__xTvgg`,
	"preview": `DiscountModal_preview__P92JZ`,
	"previewRow": `DiscountModal_previewRow__b6pEu`,
	"previewRowStrong": `DiscountModal_previewRowStrong__-Unjy`,
	"strike": `DiscountModal_strike__Vt8RV`,
	"green": `DiscountModal_green__yH9KP`,
	"pad": `DiscountModal_pad__RdDFm`,
	"padBtn": `DiscountModal_padBtn__rlN6J`,
	"padBtnWide": `DiscountModal_padBtnWide__5JuGk`,
	"actions": `DiscountModal_actions__Y0XZQ`,
	"save": `DiscountModal_save__buzW9`,
	"cancel": `DiscountModal_cancel__E7KVA`
};
export default ___CSS_LOADER_EXPORT___;
